import {
	ADD_QUALITOMETER_DETAIL_ANALYSIS,
	DETAIL_STATION_RESET,
	RECEIVE_DETAIL_INDUSTRIAL,
	RECEIVE_DETAIL_PICKUP_OPERATION,
	RECEIVE_DETAIL_PIEZOMETER_MEASURE,
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX,
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN,
	RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE,
	RECEIVE_DETAIL_POLLUTED_SOIL,
	RECEIVE_DETAIL_QUALITO,
	RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT,
	RECEIVE_DETAIL_STATION,
	RECEIVE_DETAIL_STATION_NETWORK,
	RECEIVE_ICPE_ACTIVITY,
	RECEIVE_INDUSTRIAL_ACTIVITY,
	RECEIVE_INDUSTRIAL_FAMILY,
	RECEIVE_INDUSTRIAL_SEVESO
} from '../constants/DetailStationConstants'
import ApplicationConf from '../../conf/ApplicationConf'
import fetch from 'isomorphic-fetch'
import { WaitAction } from 'react-aquasys'
import i18n from 'simple-react-i18n'
import { flatten } from 'lodash'
import { checkStatus } from '../../utils/ActionUtils'
import download from 'downloadjs'
import ToastrAction from '../../home/actions/ToastrAction'

const DetailStationAction = {
	receiveStation: function (content, type) {
		return {
			type: type,
			station: content
		}
	},
	receiveMeasures: function (content, type) {
		return {
			type: type,
			measures: content
		}
	},
	receiveNetworks: function (content) {
		return {
			type: RECEIVE_DETAIL_STATION_NETWORK,
			networks: content
		}
	},
	receiveSamplingSurfacePoint: function (content) {
		return {
			type: RECEIVE_DETAIL_QUALITO_SAMPLING_SURFACE_POINT,
			samplingSurfacePoints: content
		}
	},

	fetchDetailSation: function (id) {
		return function (dispatch) {
			dispatch(DetailStationAction.fetchStation(id))
			dispatch(DetailStationAction.fetchStationNetwork(id))
			dispatch(DetailStationAction.fetchPiezoMeasures(id))
			dispatch(DetailStationAction.fetchPiezometerMeasureMax(id))
			dispatch(DetailStationAction.fetchPiezometerMeasureMin(id))
			dispatch(DetailStationAction.fetchPiezometerMeasureMoyenne(id))
			dispatch(DetailStationAction.fetchPickupOperation(id))
			dispatch(DetailStationAction.fetchQualitoSamplingSurfacePoint(id))
			dispatch(DetailStationAction.fetchIndustrialSite(id))
			dispatch(DetailStationAction.fetchPollutedSoil(id))
		}
	},
	fetchStation: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.station.getStation(id))
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => {
						throw Error(i18n.error.nonexistent)
					}),
					404: (() => {
						throw Error(i18n.error.notFound)
					})
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveStation(json, RECEIVE_DETAIL_STATION))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},

	fetchQualito: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.qualito.getStation(id))
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveStation(json, RECEIVE_DETAIL_QUALITO))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receivePickupOperations: function (operations) {
		return {
			type: RECEIVE_DETAIL_PICKUP_OPERATION,
			pickupOperations: operations
		}
	},
	fetchPickupOperation: function (qualitometerId) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.qualito.getPickupOperation(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						idstation: qualitometerId
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receivePickupOperations(json))
					return json
				}).then(jsonResult => {
					dispatch(WaitAction.waitStart())
					const analysis = jsonResult.map((pickupOperation) => {
						dispatch(WaitAction.waitStart())
						return DetailStationAction.fetchAnalysis(pickupOperation.pickupid)
					})
					const analysisResult = flatten(analysis)
					Promise.all(analysisResult).then((ana) => {
						dispatch(WaitAction.waitStart())
						const resultAnalysis = flatten(ana)
						dispatch(DetailStationAction.receiveAnalysis(resultAnalysis))
					})
				})
		}
	},

	receiveAnalysis: function (analysis) {
		return {
			type: ADD_QUALITOMETER_DETAIL_ANALYSIS,
			analysis: analysis
		}
	},
	fetchAnalysis: function (operationId) {
		return fetch(ApplicationConf.qualito.getAnalysis(), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					idoperation: operationId
				})
		})
			.then(response => checkStatus({
				200: ((rep) => rep.json()),
				204: (() => [])
			}, response))
			.then((json = []) => {
				if (!json.error) {
					return json
				}
				return []
			})
	},

	receivePiezometerMeasure: function (measures) {
		return {
			type: RECEIVE_DETAIL_PIEZOMETER_MEASURE,
			measures: measures
		}
	},
	fetchPiezoMeasures: function (piezometerId) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.piezo.getPiezometerMeasure(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						piezometerid: piezometerId
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => [])
				}, response))
				.then((json = []) => {
					if (!json.error) {
						dispatch(DetailStationAction.receivePiezometerMeasure(json))
					}
					return []
				})
		}
	},
	fetchPiezometerMeasureMax: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.piezo.getPiezometerMeasureMax(id), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveMeasures(json, RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MAX))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	fetchPiezometerMeasureMin: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.piezo.getPiezometerMeasureMin(id), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveMeasures(json, RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MIN))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	fetchPiezometerMeasureMoyenne: function (id) {
		return function (dispatch) {
			return fetch(ApplicationConf.piezo.getPiezometerMeasureMoyenne(id), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveMeasures(json, RECEIVE_DETAIL_PIEZOMETER_MEASURE_STATISTIC_MOYENNE))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	fetchStationNetwork: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.station.getNetworks(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(
					{
						idstation: id
					})
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveNetworks(json))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	fetchQualitoSamplingSurfacePoint: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.station.getSamplingSurfacePoints(id), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveSamplingSurfacePoint(json))
					return json
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},


	receivePollutedSoil: function (pollutedSoil) {
		return {
			type: RECEIVE_DETAIL_POLLUTED_SOIL,
			pollutedSoil: pollutedSoil
		}
	},

	fetchPollutedSoil: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.pollutedSoil.get(id), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = {}) => {
					if (json && json.length > 0) {
						dispatch(DetailStationAction.receivePollutedSoil(json[0]))
						return json
					}
					return null
				}).then((jsonSampling = []) => {
					if (jsonSampling && jsonSampling.length > 0) {
						dispatch(DetailStationAction.fetchIcpeActivity())
					}
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receiveIcpeActivity: function (icpeActivity) {
		return {
			type: RECEIVE_ICPE_ACTIVITY,
			icpeActivity: icpeActivity
		}
	},

	fetchIcpeActivity: function () {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.referencial.getStandardCodification('ICPE_ACTIVITY'), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveIcpeActivity(json))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},

	receiveIndustrialSite: function (industrialSite) {
		return {
			type: RECEIVE_DETAIL_INDUSTRIAL,
			industrialSite: industrialSite
		}
	},

	fetchIndustrialSite: function (id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.industrialSite.get(id), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = {}) => {
					if (json && json.length > 0) {
						dispatch(DetailStationAction.receiveIndustrialSite(json[0]))
						return json
					}
					return null
				}).then((jsonSampling = []) => {
					if (jsonSampling && jsonSampling.length > 0) {
						dispatch(DetailStationAction.fetchIndustrialSiteFamily())
						dispatch(DetailStationAction.fetchIndustrialSiteSeveso())
						dispatch(DetailStationAction.fetchIndustrialSiteActivity())
					}
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	receiveIndustrialSiteFamily: function (industrialFamily) {
		return {
			type: RECEIVE_INDUSTRIAL_FAMILY,
			industrialFamily: industrialFamily
		}
	},

	fetchIndustrialSiteFamily: function () {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.referencial.getStandardCodification('INDUSTRIAL_FAMILY'), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveIndustrialSiteFamily(json))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},

	receiveIndustrialSiteSeveso: function (industrialSeveso) {
		return {
			type: RECEIVE_INDUSTRIAL_SEVESO,
			industrialSeveso: industrialSeveso
		}
	},

	fetchIndustrialSiteSeveso: function () {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.referencial.getStandardCodification('INDUSTRIAL_SEVESO'), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveIndustrialSiteSeveso(json))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},

	receiveIndustrialSiteActivity: function (industrialActivity) {
		return {
			type: RECEIVE_INDUSTRIAL_ACTIVITY,
			industrialActivity: industrialActivity
		}
	},

	fetchIndustrialSiteActivity: function () {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.referencial.getStandardCodification('INDUSTRIAL_ACTIVITY'), {
				method: 'GET'
			})
				.then(response => checkStatus({
					200: ((rep) => rep.json()),
					204: (() => []),
					404: (() => [])
				}, response))
				.then((json = []) => {
					dispatch(DetailStationAction.receiveIndustrialSiteActivity(json))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},

	exportStation(id) {
		return function (dispatch) {
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.station.exportStation(id), {
				method: 'GET',
				headers: { authorization: btoa('Basic ' + atob(sessionStorage.getItem('TOKEN'))) }
			})
				.then(response => checkStatus({
					200: ((rep) => rep.blob())
				}, response))
				.then((blob) => {
					download(blob, 'station_' + id + '.zip', blob.type)
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	synchroniseAdesSites: function (id, code) {
		return function (dispatch) {
			const body = JSON.stringify(
				{
					code: code
				})
			dispatch(WaitAction.waitStart())
			return fetch(ApplicationConf.webService.ades(), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: body
			})
				.then(response => checkStatus({
					200: (() => [])
				}, response))
				.then(() => {
					dispatch(DetailStationAction.fetchDetailSation(id))
				}).then(() => {
					dispatch(WaitAction.waitStop())
				})
				.catch(() => {
					dispatch(ToastrAction.error(i18n.error.errorLoadingData))
					dispatch(WaitAction.waitStop())
				})
		}
	},
	reset() {
		return {
			type: DETAIL_STATION_RESET
		}
	}
}

export default DetailStationAction



// WEBPACK FOOTER //
// ./src/station/actions/DetailStationAction.js